<template>
  <footer id="site-footer" class="relative">
    <section v-if="footer.length" class="py-5 bg-white">
      <ul class="flex flex-col mx-auto p-4 max-w-6xl lg:flex-row">
        <li
          v-for="(menu, index) in footer"
          :key="index"
          class="flex-1 pb-6 leading-10 border-gray-700 lg:pt-0 lg:border-b-0"
          :class="{
            'border-b-2': index <= footer.length,
            'pt-6 lg:pl-8': index > 0,
            'lg:border-r lg:pr-8': index >= 0 && index < footer.length - 1,
          }"
        >
          <ul>
            <li>
              <h3 class="text-black mb-4 font-bold leading-4">
                <AtomLink v-if="menu.url" :title="menu.title" :url="menu.url" class="text-black border-b-2 hover:border-app-green border-transparent cursor-pointer">
                  {{ menu.title }}
                </AtomLink>
                <template v-else>{{ menu.title }}</template>
              </h3>
            </li>
            <template v-for="(child, childKey) in menu.children">
              <li v-if="child.url" :key="childKey">
                <AtomLink :title="child.title" :url="child.url" :class="{ 'text-black border-b-2 hover:border-app-green border-transparent cursor-pointer': child.url }">
                  {{ child.title }}
                </AtomLink>
              </li>
            </template>

            <template v-if="index === 1 && site === 'default'">
              <li>
                <a href="http://www.beterlevenkeurmerk.nl/" title="Beter leven keurmerk" target="_blank">
                  <AtomBrandBlijeKipLogo class="inline mr-3 w-20" />
                </a>
              </li>
            </template>

            <template v-if="index === 2 && site === 'default'">
              <li>
                <MoleculeFooterSocialMedia />
              </li>
            </template>

            <template v-if="index === 3">
              <li>
                <a href="https://www.postcodeloterij.nl/goede-doelen/overzicht/dierenbescherming" :title="$t('footer.nationale-postcode-loterij')" target="_blank">
                  <AtomBrandNplLogo class="inline mr-3 my-3 w-16 lg:w-12" width="64px" height="42px" />
                </a>
                <a
                  href="https://www.dierenbescherming.nl/wat-wij-doen/over-ons/organisatie/inschrijving-anbi"
                  title="ANBI"
                  target="_blank"
                  class="hover:text-app-green transform transition duration-200 ease-in-out"
                >
                  <AtomBrandAnbiLogo class="inline mr-3 my-3 w-16 lg:w-12" width="64px" height="25px" />
                </a>
                <a href="https://www.cbf.nl/organisatie/dierenbescherming" title="CBF" target="_blank" class="hover:text-app-green transform transition duration-200 ease-in-out">
                  <AtomBrandCbfLogo class="inline mr-3 my-3 w-16 lg:w-12" width="64px" height="35px" />
                </a>
              </li>
            </template>
          </ul>
        </li>
      </ul>
    </section>
    <section v-if="bottom.length" class="flex px-5 py-2 text-xs bg-app-green-100 md:text-base">
      <h4 class="sr-only">Footer service links</h4>
      <div class="flex flex-col md:flex-row md:items-center md:ml-auto">
        <AtomLink v-for="(item, index) in bottom" :key="index" :url="item.url" class="mr-12 text-black hover:underline cursor-pointer">{{ item.title }}</AtomLink>
      </div>
    </section>
    <button
      :aria-label="t_('to-top')"
      class="group absolute right-0 top-0 mr-0 mt-0 px-4 py-3 bg-app-lime hover:bg-black rounded-bl-lg shadow-lg cursor-pointer transition duration-200"
      @click="scrollToTop"
    >
      <AtomIconArrowUp class="w-5 group-hover:text-white transition duration-200" />
    </button>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { setupSiteConfig } from '~/composables/craft'
import { setupTranslationPrefixer } from '~/composables/util'
import { useNavigationStore } from '~/store/navigation'

const { site } = setupSiteConfig()
const scrollToTop = () => {
  window.scrollTo(0, 0)
}

const navigationStore = useNavigationStore()
const bottom = computed(() => navigationStore.bottom)
const footer = computed(() => navigationStore.footer)

const { t_ } = setupTranslationPrefixer('footer')
</script>
